import { PublicClientApplication } from '@azure/msal-browser';
import setupAccessTokenInterceptor from './access-token-interceptor';

const setupInterceptors = (msalInstance: PublicClientApplication) => {
  if (process.env.REACT_APP_CLIENT_AUTHENTICATION === 'true') {
    setupAccessTokenInterceptor(msalInstance);
  }
  // More global axios interceptors can be registered here
};

export default setupInterceptors;
